import { render, staticRenderFns } from "./BaseSlotLabel.vue?vue&type=template&id=316ae714&scoped=true&"
import script from "./BaseSlotLabel.vue?vue&type=script&lang=js&"
export * from "./BaseSlotLabel.vue?vue&type=script&lang=js&"
import style0 from "./BaseSlotLabel.vue?vue&type=style&index=0&id=316ae714&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ae714",
  null
  
)

export default component.exports